import { useAuth } from '../context/AuthContext';

export const usePermission = () => {
  const { user } = useAuth();
  
  // 1. Super Admin: Access Everything
  if (user?.role === 'super_admin') {
      return { 
          can: () => true, 
          role: 'super_admin' 
      };
  }

  // 2. Staff: Check specific permission list
  const can = (permissionSlug) => {
      if (!user || !user.permissions) return false;
      return user.permissions.includes(permissionSlug);
  };

  return { can, role: user?.role };
};